require('./policiesDialog.style.scss');

class PoliciesDialogController {
    constructor($scope, $filter, virtualMachinesPersistence, dialogService, $attrs, $timeout) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$attrs = $attrs;
        this.$timeout = $timeout;
        this.persistence = virtualMachinesPersistence;
        this.dialogService = dialogService;
        this.modalTitle = this.$filter('translate')('component.protectionGroupDialog.title');
        this.selectedProtectionGroups = [];
        this.configPgTable();
    }

    $onInit() {
        this.actionButton = [
            {
                title: this.$filter('translate')('component.protectionGroupDialog.btn.unassign.label'),
                action: () => this.clearPGs(true),
                isDisabled: () => !this.isUnassignAllEnbled || this.busy,
                id: this.$attrs.eventId + '-unassign',
            },
            {
                title: this.$filter('translate')('component.protectionGroupDialog.btn.assign.label'),
                action: () => this.assignPolicy(this.selectedProtectionGroups[0]),
                isDisabled: () => !this.selectedProtectionGroups.length || this.busy,
                id: this.$attrs.eventId + '-assign',
            },
        ];
    }

    onOpen() {
        this.id = this.$attrs.eventId + '-close';
        this.closeId = { close: this.$attrs.eventId + '-close', closeIcon: this.$attrs.eventId + '-close-icon' };
        // this.resetValue();
        this.load(true);
    }

    onClose() {
        this.resetValue();
    }

    load(firstPage) {
        this.busy = true;
        return this.persistence.getProtectionGroups(firstPage).then((protectionGroups) => {
            this.protectionGroups = protectionGroups;
            this.isUnassignAllEnbled = this.enableClearAllButton(this.selectedItems);
            this.currentProtectionGroup = this.getProtGroupOfItems(this.selectedItems);
            if (this.currentProtectionGroup && this.currentProtectionGroup.length === 1) {
                this.selectedProtectionGroups = this.protectionGroups.filter(
                    (item) => item.uuid === this.currentProtectionGroup[0]
                );
            }
            this.busy = false;
        });
    }

    getProtGroupOfItems(selectedItems) {
        if (!selectedItems || !selectedItems.length) {
            return null;
        }
        let itemsPgName = selectedItems.filter((item) => item.policy).map((i) => i.policy);
        return this.protectionGroups.filter((pg) => itemsPgName.indexOf(pg.name) > -1).map((i) => i.uuid);
    }

    enableClearAllButton(selectedItems) {
        return selectedItems && selectedItems.filter((item) => item.policy).length > 0;
    }

    clearPGs(clearAll) {
        let protectionGroup = !clearAll ? this.selectedProtectionGroups[0] : null,
            temp = this.selectedItems.filter((item) => item.policy);
        if (temp.length === temp.filter((item) => item.policy.toUpperCase() === 'EXCLUDE').length) {
            this.unassignAction(protectionGroup);
        } else {
            this.unassignDialog(clearAll).then((result) => {
                if (!result) return false;
                this.unassignAction(protectionGroup);
            });
        }
    }

    unassignDialog(clearAll) {
        return this.dialogService.showYesNo(
            clearAll
                ? this.$filter('translate')('policy.dialog.unassignAllPG.text')
                : this.$filter('translate')('policy.dialog.unassignPG.text'),
            this.$filter('translate')('policy.dialog.unassignPG.title'),
            this.$filter('translate')('policy.dialog.unassignPG.notice', 'unassign-pg')
        );
    }

    unassignAction(protectionGroup) {
        this.busy = this.onUnAssign({ protectionGroup });
        this.resetValue();
    }

    assignPolicy(protectionGroup) {
        this.busy = this.onAssign({ protectionGroup });
        this.resetValue();
    }

    configPgTable() {
        this.protectionTableConfig = [
            this.$filter('translate')('component.protectionGroupDialog.table.header.name'),
            this.$filter('translate')('component.protectionGroupDialog.table.header.description'),
        ];
    }

    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: [],
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('50%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('50%');

        this.$timeout(() => {
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    resetValue() {
        this.persistence.protectionTableState.searchBy = '';
        this.isUnassignAllEnbled = null;
        this.protectionGroups = [];
        this.selectedProtectionGroups = [];
        this.currentProtectionGroup = [];
    }
}

PoliciesDialogController.$inject = [
    '$scope',
    '$filter',
    'virtualMachinesPersistence',
    'dialogService',
    '$attrs',
    '$timeout',
];

const policiesDialogComponent = {
    controller: PoliciesDialogController,
    template: require('./policiesDialog.template.html'),
    bindings: {
        showModal: '=',
        selectedItems: '<',
        onAssign: '&',
        onUnAssign: '&',
    },
};

module.exports = policiesDialogComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/dialogs/policiesDialog/policiesDialog.component.js